<template>
  <form @submit.prevent="createOccupation" role="form">
    <div class="row no-print">
      <div class="col-12 col-md-6 p-b-15">
        <autocomplete
          ref="searchAutocomplete"
          :url="autocompleteUrl"
          :customHeaders="custom_headers"
          :placeholder="$t('Occupations.name_placeholder')"
          anchor="name"
          name="autocomplete"
          label=""
          param="name"
          :classes="{ wrapper: 'form-wrapper', input: 'form-control pull-right', list: 'data-list', item: 'data-list-item' }"
          :encodeParams='true'
          :min='3'
          :onSelect="selectInput"
        >
        </autocomplete>
      </div>
      <div class="col-6 col-md-3 p-b-15">
        <button type="submit" class="btn btn-secondary btn-block btn-cons" name="create-occupation">
          <span>{{ $t('actions.add') }}</span>
        </button>
      </div>
    </div>
  </form>
</template>

<script type="text/javascript">
  import Autocomplete from 'vue2-autocomplete-js';
  import { getAccessToken } from '@/backend/storage'

  export default {
    components: { Autocomplete },
    props: ['currentEntity'],
    data: function () {
      return ({
        occupation: {
          corporation_id: '',
          entity_id: '',
          name: ''
        }
      })
    },
    computed: {
      autocompleteUrl() {
        // this is not the right list, in the future it will be a list of existing occupation to help user write the occupation
        return process.env.API_URL + '/v1/entities/' + this.currentEntity.id + '/occupations'
      },
      custom_headers() {
        return {Authorization: 'bearer ' + getAccessToken()}
      },
    },
    methods: {
      createOccupation() {
        this.occupation.name = this.$refs.searchAutocomplete.type
        this.occupation.corporation_id = this.currentEntity.corporation.id
        this.occupation.entity_id = this.currentEntity.id
        if (this.occupation.name != '') {
          this.$store.dispatch('occupations/create', this.occupation)
          .then(data => {
            this.$refs.searchAutocomplete.clearInput()
          })
        }
      },
      selectInput(occupation) {
        this.occupation = occupation
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/occupations/OccupationForm.vue